export default class SectionReadDto{
    public id:number;
    public section:string;
    public visibility:boolean;
}